import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// アプリ内フィードバックフォーム (#2469)。
// connect 時にモーダルを自動表示し、以下の3操作でそれぞれ1回だけ送信する:
//   - 「回答する」  → status=answered(設問回答つき)
//   - 「回答しない」→ status=declined
//   - ×/背景クリックで閉じる → status=closed(未操作クローズ)
// どの操作でも5ヶ月抑止の起点が記録される。二重送信は submitted フラグで防ぐ。
export default class extends Controller {
  static values = { createUrl: String };

  connect() {
    this.submitted = false;
    this.modal = Modal.getOrCreateInstance(this.element);
    // ×/背景クリック等で閉じたとき、まだ送信していなければ closed を記録する。
    this.onHidden = () => {
      if (!this.submitted) this.send("closed");
    };
    this.element.addEventListener("hidden.bs.modal", this.onHidden);
    this.modal.show();
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this.onHidden);
    if (this.modal) this.modal.dispose();
  }

  // 「回答する」: 設問回答つきで送信して閉じる。
  answer(event) {
    event.preventDefault();
    this.send("answered", new FormData(this.formElement()));
    this.hide();
  }

  // 「回答しない」: 回答なしで送信して閉じる。
  decline(event) {
    event.preventDefault();
    this.send("declined");
    this.hide();
  }

  hide() {
    this.submitted = true;
    this.modal.hide();
  }

  formElement() {
    return this.element.querySelector("form");
  }

  send(status, formData = new FormData()) {
    if (this.submitted && status === "closed") return;
    this.submitted = true;

    formData.set("status", status);
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;

    fetch(this.createUrlValue, {
      method: "POST",
      headers: { Accept: "application/json", "X-CSRF-Token": csrfToken },
      body: formData,
    }).catch(() => {
      // 送信に失敗しても会話を壊さない(次回ログインで再表示される)。
    });
  }
}
